module.exports = __webpack_public_path__ + "static/media/fruit_truck.93f38ed1.jpeg";